import script from "./autograph.vue?vue&type=script&lang=ts&setup=true"
export * from "./autograph.vue?vue&type=script&lang=ts&setup=true"

import "./autograph.vue?vue&type=style&index=0&id=1e6c56e3&lang=less&scoped=true"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6c56e3"]])

export default __exports__